import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFeather: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="feather, writing"><path d="M4.75 21.25C4.75 12 8.375 2.75 19.25 2.75C19.25 6.86111 14.5893 9.94444 14.5893 9.94444L16.6607 11.4861C16.6607 11.4861 14.5893 18.1667 5.5 18.1667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFeather;
